import Icon from '@material-ui/icons/Movie';

import List from './List';

export default {
  name: 'walls/movie',
  icon: Icon,
  list: List,
};
